import useSidebarPermissions from "@/hooks/general/useSidebarPermissions";
import { Navigate } from "react-router-dom";

const DefaultRedirect = () => {
  const { firstAccessiblePath } = useSidebarPermissions();

  return <Navigate to={firstAccessiblePath} replace />;
};

export default DefaultRedirect;
